<div class="sp-row__space">
  <div class="sp-row__align">
    <mat-icon
      class="sp-color__primary sp-hidden__before-md sp-cursor__pointer"
      (click)="onBackClick()">
      arrow_back
    </mat-icon>
    <h2 class="sp-margin__left sp-color__primary sp-hidden__before-md">{{ getShrinkedID() }}</h2>
    <h3 class="sp-margin__left sp-color__primary sp-hidden__after-md">{{ getShrinkedID() }}</h3>
  </div>
  <div class="sp-row__align">
    <button
      (click)="onAddClick()"
      mat-icon-button
      [matTooltip]="'PRODUCT_SUBCATEGORY.ADD_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> add_circle </mat-icon>
    </button>

    <button
      (click)="refresh.emit()"
      mat-icon-button
      [matTooltip]="'GENERAL.REFRESH_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
    </button>
  </div>
</div>
